import r from "./isFunction.js";
function n(n) {
  var o = [];
  for (var t in n) r(n[t]) && o.push(t);
  return o.sort();
}
export { n as default };